<template>
  <div class="fbc-zone-edu-comparison-container">
    <zm-table
      :data="treeData"
      v-bind="tableProps"
      :stripe="stripe"
      highlight-current-row
      :max-height="maxHeight"
    >
      <zm-table-column
        fixed
        prop="feature"
        min-width="100"
        label="">
        <template slot-scope="scope">
              <div class="plan-comparison-feature">
              <span class="plan-comparison-feature__text" v-html="scope.row.feature"></span>
              <zm-tooltip v-if="scope.row.tooltip" placement="top">
                <div slot="content" v-html="scope.row.tooltip" />
                <i @mouseenter="onTooltipHover(scope.row.feature)" :aria-label="scope.row.feature" tabindex="-1" style="color: #0B5CFF" class="zm-icon-info-outline"></i>
              </zm-tooltip>
              <span
                tabindex="-1"
                class="feature-content"
                :class="[
                  scope.row.subTitle ? 'sub-title' : 'sub-text',
                ]"
              ></span>
              <auto-expire-badge :badgeId="scope.row.badgeId" :theme="'comparison'" style="margin-left: 4px;"/>
          </div>
          <div v-if="scope.row.link" class="plan-comparison-link">
            <span :class="scope.row.link.classname"
                  :style="scope.row.link.style"
                  style="cursor: pointer"
                  @click="onLinkClick(scope.row)"
                  :aria-label="scope.row.link.ariaLabel">
              {{ scope.row.link.text }}
            </span>
          </div>
        </template>
      </zm-table-column>
      <zm-table-column
        v-for="(col, idx) in colConfig"
        :key="col.key + idx"
        align="center">
        <slot name="comparison-table-header" slot="header" :col="col">
          <div class="plan-comparison-header">
            <p class="plan-comparison-header__title">{{ col.title }}</p>
            <img src="../../assets/checked.svg" alt="">
          </div>
        </slot>
        <template slot-scope="scope">
          <div class="plan-comparison-detail">
            <span v-if="isString(scope.row[col.key])"
                  class="plan-comparison-detail__text"
                  v-html="scope.row[col.key]">
            </span>
            <template v-else-if="isBoolean(scope.row[col.key]) || scope.row[col.key] === undefined">
              <img v-if="scope.row[col.key]" src="../../assets/checked.svg" alt=""/>
              <img v-else src="../../assets/uncheck.svg" alt=""/>
            </template>
            <template v-else-if="isObject(scope.row[col.key])">
              <div class="plan-comparison-link-extra">
                <p v-if="scope.row[col.key].text" class="plan-comparison-link-extra__text">{{ scope.row[col.key].text }}</p>
                <a v-if="scope.row[col.key].link"
                    class="plan-comparison-link-extra__link"
                    tabindex="-1"
                    :aria-label="scope.row[col.key].link"
                    :class="[{
                      'plan-comparison-link-extra__disabled': scope.row[col.key].disabled
                    },
                    ...(scope.row[col.key].linkClass || [])
                    ]"
                    @click="scope.row[col.key].callback()">
                  {{ scope.row[col.key].link }}
                </a>
                <p v-if="scope.row[col.key].extra">{{ scope.row[col.key].extra }}</p>
              </div>
            </template>
          </div>
        </template>
      </zm-table-column>
    </zm-table>
  </div>

</template>

<script>
import { defaultColConfig } from '../../datas/zoomone-edu-comparison';
import { t } from '../../plugins/i18n'
import { isBoolean, isObject, isString } from 'lodash';
import AutoExpireBadge from '@/components/AUTO_EXPIRE_BADGE';

export default {
  components: {
    AutoExpireBadge
  },
  props: {
    // pricing  opc  nbp
    appName: {
      type: String,
      default: 'pricing'
    },
    colConfig: {
      type: Array,
      default: ()=> {
        return defaultColConfig
      }
    },
    tableProps: {
      type: Object,
      default: ()=> {}
    },
    maxHeight: {
      default: 800,
    },
    treeData: {
      type: Array,
      default: () => [],
    },
    eventTracking: {
      type: Object,
    },
  },
  computed: {
    isPricingApp() {
      return this.appName === 'pricing'
    },
    stripe() {
      return this.isPricingApp
    }
  },
  methods: {
    isObject,
    isBoolean,
    isString,
    t,
    onLinkClick(row) {
      if (row.link?.hasLearnMore) {
        this.eventTracking?.learnMoreCallback && this.eventTracking?.learnMoreCallback(row.feature)
      }
      row.link.callback()
    },
    onTooltipHover(f) {
      this.eventTracking?.tooltipHoverCallback && this.eventTracking?.tooltipHoverCallback(f)
    }
  }
}

</script>

<style lang="scss">
.fbc-zone-edu-comparison-container {
  .cell-desc {
    font-size: 14px;
    line-height: 12px;
    color: #666487;
    text-align: center;
    display: block;
  }
  @mixin title {
    color: #00053D;
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
  }
  .plan-comparison-feature {
    .zm-tooltip {
      margin-left: 4px;
    }
    &__text {
      @include title
    }
  }
  .plan-comparison-detail {
    &__text {
      @include title
    }
  }
  .plan-comparison-header {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    img {
      width: 16px;
      height: 16px;
    }
    &__title {
      text-align: center;
      font-weight: 400;
      font-size: 16px;
      color: #00031F;
      line-height: 24px;
    }
  }
  .plan-comparison-link-extra {
    &__text {
      @include title
    }
    &__link {
      cursor: pointer;
      color: #0B5CFF;
      font-weight: 400;
      font-size: 12px;
      line-height: 18px;
    }
    &__disabled {
      pointer-events: none;
      color: #666487;
      font-weight: 400;
      font-size: 12px;
      line-height: 18px;
    }
  }
}
</style>
